export default [
  {
    path: '/home',
    name: 'Home',
  },
  {
    path: '/original_exam',
    name: 'OriginalExam',
  },
  {
    path: '/preset_exam',
    name: 'PresetExam',
  },
  {
    path: '/result',
    name: 'Result',
  },
  {
    path: '/change',
    name: 'Change',
  },
  {
    path: '/score_setting',
    name: 'ScoreSetting',
  },
  {
    path: '/regist_exam',
    name: 'RegistExam',
  },
  {
    path: '/history',
    name: 'History',
  },
]
